import type { ExecLogColumn } from "./execLogColumns";

// RFC 4180 quoting: wrap a field in quotes when it holds a comma, quote or
// line break, and double any quote inside it.
function field(value: unknown): string {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Header row from the column labels, then one line per row in column order. */
export function toCsv(columns: ExecLogColumn[], rows: Record<string, unknown>[]): string {
  const header = columns.map((c) => field(c.label)).join(",");
  const body = rows.map((row) => columns.map((c) => field(row[c.key])).join(","));
  return [header, ...body].join("\r\n") + "\r\n";
}
